module.exports = "/_next/static/images/8ebed1d20125d718dd61ba724f492faf-pregnant-woman@tablet@1x.jpg";